import React, { Component } from "react";
import { MenuCompany } from "../components/MenuCompanySelect";
import "../css/companyDash-style.css"
import Swal from "sweetalert2";
import { getInformationWithData } from "../services/CABE";
import { getValueCookie, setNewCookie } from "../services/cookieService";
import { v4 as uuidv4 } from 'uuid';
import { GetNumberOfOrders } from "../functions/pagesFunction";

export default class CompanyDashBoard extends Component {
    state = {
        General: {
            CompanysofUser: []
        }
    }

    componentDidMount() {
        // Load companies V2
        this.getCompanysAssigned();
    }

    async getCompanysAssigned() {
        const data = {
            userName: getValueCookie('userName')
        }
        console.log(data)
        // Get assigned companies
        const info = await getInformationWithData('/v2/company/CatalogueofCompanies', data);
        
        // Validate error
        if ("error" in info) {
            Swal.fire({
                title: `Invalid session or expired`,
                text: "Please, login again.",
                icon: 'warning',
                confirmButtonColor: '#14398a',
                cancelButtonColor: '#626262',
                showCancelButton: true,
                confirmButtonText: 'Yes, Login again.',
                cancelButtonText: 'No, cancel.',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.assign("/logout");
                }
            })
        }
        
        // Request successful
        if (info.status.code === 1) {
            const temporal = this.state.General;
            temporal.CompanysofUser = info.data;
            this.setState({ General: temporal });
        } else {
            // Distinguish worker-offline from generic error
            const isWorkerOffline = info.workerOffline || info.workerTimeout;
            return Swal.fire({
                title: isWorkerOffline ? '⚙️ Backend Reconnecting' : 'Connection Error',
                text: isWorkerOffline
                    ? 'The MAS90/SAGE service is reconnecting. Please wait a few seconds and try again.'
                    : 'Could not load company list. Please check your internet connection and try again.',
                icon: isWorkerOffline ? 'info' : 'warning',
                confirmButtonColor: '#14398a',
                showCancelButton: isWorkerOffline,
                confirmButtonText: isWorkerOffline ? 'Retry' : 'OK',
                cancelButtonText: 'Cancel',
            }).then(result => {
                if (isWorkerOffline && result.isConfirmed) {
                    this.getCompanysAssigned();
                }
            });
        }
    }

    // Select company and redirect
    async SelectCompany(company) {        
        setNewCookie('CompanyLogo', company.directoryLogo, 50);
        setNewCookie('DocumentsLogo', company.optionalDirectoryLogo, 50);
        setNewCookie('TypeUser', company.idTypeofUser, 50);
        setNewCookie('SalesPerson', company.salesPerson, 50);

        if (company.idCompany === 3) {
            let total = await GetNumberOfOrders(company.salesPerson);
            setNewCookie('TotalOrders', total, 50);
        }

        // Get company full data
        const data = {companyid: company.idCompany};
        const information = await getInformationWithData('/v2/company/getCompanyInformation', data)
        // Set belongs to or sub company
        if (information.status.code === 1) {
            if (information.data[0].belongs_to) {
                setNewCookie('SubCompanyId', information.data[0].belongs_to, 50);
                setNewCookie('CompanyId', information.data[0].belongs_to, 50);
            } else {
                setNewCookie('CompanyId', company.idCompany, 50);
            }
            // Set company name and company id
            setNewCookie('Company', company.name, 50);
            // Session no
            window.localStorage.setItem('session', uuidv4());
            // Set company extra data
            setNewCookie('fullName', information.data[0].fullname, 50);
            setNewCookie('address', information.data[0].address, 50);
            setNewCookie('warehouse', information.data[0].city + " Warehouse", 50);
            setNewCookie('website', information.data[0].webSite, 50);
            setNewCookie('phone', information.data[0].phone, 50);
            setNewCookie('apiPrefix', information.data[0].apiPrefix, 50);
            
            // Redirect for admin or not admin user
            if (company.admin) {
                window.location.assign("/admin/dashboard");
            } else {
                window.location.assign("/sales/dashboard");
            }
        } else {
            const isWorkerOffline = information.workerOffline || information.workerTimeout;
            return Swal.fire({
                title: isWorkerOffline ? '⚙️ Backend Reconnecting' : 'Connection Error',
                text: isWorkerOffline
                    ? 'The MAS90/SAGE service is reconnecting. Please wait a few seconds and try again.'
                    : 'Could not load company information. Please try again.',
                icon: isWorkerOffline ? 'info' : 'warning',
                confirmButtonColor: '#14398a',
                confirmButtonText: 'OK',
            });
        }
    }

    render() {
        return (
            <div id="companydash">                
                <MenuCompany />
                
                <main className="">
                    <div className="container-fluid generalContainer" id="actualPage">
                        <div className="text-center">
                            <p className="company-text">Select your company</p>
                        </div>
                        <div className="container px-4">
                            <div className="row gx-5 justify-content-center">
                                {this.state.General.CompanysofUser.map((company, i) => (
                                    <div key={i} className="col-sm-6 col-md-3 p-3 pb-4">
                                        <div 
                                        className={`card company-card${i} text-center`} 
                                        onClick={() => this.SelectCompany(company)}
                                        >
                                        <div className="card-body">
                                            <div className="company-logo mb-3">
                                            <img 
                                                src={company.directoryLogo} 
                                                alt={`${company.name} logo`} 
                                                className="img-fluid"
                                                style={{maxHeight: 100}}
                                            />
                                            </div>
                                            <h5 className="company-name">{company.name}</h5>
                                        </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </main>
                {/* <Footer /> */}
            </div>
        )
    }
}
